<template>
  <div class="c-confirm-payment">
    <div class="message">
      <div class="message-container">
        <div class="text">
          <h3>Подтверждение оплаты</h3>
          <p>Выберите дату начала периода</p>
        </div>

        <c-calendar :value.sync="date" />

        <div class="buttons">
          <n-button
            flat
            class="modal-button cancel"
            @click="disagree"
          >
            Нет
          </n-button>

          <n-button
            flat
            class="modal-button agree"
            :disabled="loading"
            @click="agree"
          >
            {{ loading ? 'Сохранение...' : 'Да' }}
          </n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CCalendar from '../../components/calendar/Index.vue'

export default {
  name: 'CConfirmPayment',

  components: {
    CCalendar,
  },

  props: {
    company: {
      type: Object,
      default: () => ({}),
    },

    tariff: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      date: new Date(),
      loading: false,
    }
  },

  methods: {
    agree() {
      if (this.loading) return

      this.loading = true
      this.$var('load', true)

      const data = {
        startAt: this.date,
      }

      $api.companies.confirmPayment(this.company?.id, data)
        .then(() => {
          this.$emit('success')
          this.close()
        })
        .finally(() => {
          this.loading = false
          this.$var('load', false)
        })
    },

    disagree() {
      this.$emit('cancel')
      this.close()
    },

    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped lang="scss">
.c-confirm-payment {
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1020;
  background: rgba(0, 0, 0, 0.05);
  align-items: center;
  justify-content: center;

  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    border-radius: 16px;
    padding: 30px;
    min-width: 420px;

    .message-container {

      .text {
        h3 {
          margin: 0 0 4px 0;
          padding: 0;
          font-size: 18px;
          font-weight: 700;
          color: var(--primary);
          text-align: center;
        }

        p {
          text-align: center;
          margin: 12px 0;
          color: var(--primary);
          padding: 0;
          font-size: 16px;
        }
      }

      .buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-width: 250px;
        margin-top: 24px;

        :deep() {
          .n-button {
            border: none;
            border-radius: 12px;
            height: 42px;
            min-width: 120px;
            background-color: var(--primary);
            color: #FFFFFF;

            &.cancel {
              background-color: #ffffff;
              color: var(--primary);
              font-weight: 700;
              border: 1px solid var(--primary);
            }
          }
        }
      }
    }
  }
}
</style>
